module.exports = __webpack_public_path__ + "static/media/hurricane-harvey-3624911_640.2cf9733d.jpg";